import mapItemToCartItem from '@/helpers/mapItemToCartItem'

function recalculateCartTotal (state) {
  state.total = state.items.reduce((sum, item) => sum + item.cant * item.precio, 0)
}

const mutations = {
  setItem (state, item) {
    const existingItem = state.items.findIndex(i => i.productId === item.id)
    if (existingItem > -1) {
      if (state.items[existingItem].cant !== item.cant && !state.items[existingItem].esCombinado) {
        // state.items[existingItem].cant = item.cant
        state.items[existingItem] = mapItemToCartItem(item)
      } else {
        const _cartItem = mapItemToCartItem(item)
        state.items.push(_cartItem)
      }
    } else {
      const _cartItem = mapItemToCartItem(item)
      state.items.push(_cartItem)
    }
  },
  setItems (state, items) {
    state.items.concat(items)
  },
  eraseItem (state, itemToRemove) {
    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i]._id === itemToRemove._id) { state.items.splice(i, 1) }
    }
  },
  eraseItemCarta (state, itemToRemove) {
    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i].productId === itemToRemove.id) { state.items.splice(i, 1) }
    }
  },
  calculateAmountWhenItemIsAdded (state) {
    recalculateCartTotal(state)
  },
  adjustLineQuantity (state, { _id, delta }) {
    const idx = state.items.findIndex((i) => i._id === _id)
    if (idx === -1) return
    const item = state.items[idx]
    const newCant = item.cant + delta
    if (newCant <= 0) {
      state.items.splice(idx, 1)
    } else {
      state.items[idx].cant = newCant
    }
    recalculateCartTotal(state)
  },
  calculateAmountWhenItemIsRemoved (state, itemToRemove) {
    state.total -= (itemToRemove.cant * itemToRemove.precio)
  },
  resetItems (state) {
    state.items = []
    state.total = 0
  },
  editItem (state, params) {
    const existingItem = state.items.findIndex(i => i.productId === params.id)
    if (existingItem > -1) {
      const item = state.items[existingItem]
      item.canApplyDiscoint = params.applyDiscoint
      state.items[existingItem] = item
    }
  }
}

export default mutations
